import fornecedoresMenu from '../fornecedor/contratos/menu'
import financeiroMenu from './financeiro/menu'
import aprovadoresMenu from './aprovadores/menu'
import gestoresMenu from './gestores/menu'
import gerentesMenu from './gerentes/menu'
import uabsMenu from './uabs/menu'
import apoiosMenu from './apoios/menu'
import relatoriosConveniosMenu from './relatoriosconvenios/menu'
import relatoriosContratosMenu from './relatorioscontratos/menu'
import fornecedorConvenioMenu from './convenios/fornecedor/menu'
import gestorConvenioMenu from './convenios/gestor/menu'
import financeiroConvenioMenu from './convenios/financeiro/menu'

export default {
    name: 'GESCON',
    url: '/gescon',
    icon: 'fa fa-book',
    regras: [
        ...fornecedoresMenu.map(r => r.regras),
        ...financeiroMenu.map(r => r.regras),
        ...aprovadoresMenu.map(r => r.regras),
        ...gestoresMenu.map(r => r.regras),
        ...gerentesMenu.map(r => r.regras),
        ...uabsMenu.map(r => r.regras),
        ...apoiosMenu.map(r => r.regras),
        ...relatoriosContratosMenu.map(r => r.regras),
        ...relatoriosConveniosMenu.map(r => r.regras),
        ...fornecedorConvenioMenu.map(r => r.regras),
        ...gestorConvenioMenu.map(r => r.regras),
        ...financeiroConvenioMenu.map(r => r.regras)
    ],
    children: [...fornecedoresMenu, ...gestoresMenu, ...gerentesMenu, ...financeiroMenu, ...uabsMenu, ...apoiosMenu, ...aprovadoresMenu, ...relatoriosConveniosMenu, ...relatoriosContratosMenu,
    ...fornecedorConvenioMenu, ...gestorConvenioMenu,...financeiroConvenioMenu]
}
